export const SET_SLIDER_LOCK = 'SET_SLIDER_LOCK';

function setSliderLock(value) {
  return {
    type: SET_SLIDER_LOCK,
    payload: value,
  };
}

export function sliderUnsetLock() {
  return (dispatch) => dispatch(setSliderLock(false));
}



// WEBPACK FOOTER //
// ./common/actions/bgslider.js